import { useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '@src/container';
import { AuthService } from '@src/application/users/usecases';
import { ToastService } from '@src/shared/services/toast.service';

/**
 * Hook: useLogout
 * Handles user logout
 * 
 * @example
 * const { mutate: logout, isPending } = useLogout();
 * logout();
 */
export function useLogout() {
    const authService = container.resolve<AuthService>('authService');
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            await authService.logout();
        },
        onSuccess: () => {
            // Clear all cached queries
            queryClient.clear();
            ToastService.success('Logged out successfully');
        },
        onError: (error: Error) => {
            ToastService.error(error.message || 'Logout failed');
        },
    });
}
